export default "__VITE_ASSET__xTi$X42b__"